export default __webpack_public_path__ + "static/media/active.d98a5f0b.svg";